import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SECONDS = 15 * 60; // 15 minutos
interface CountdownTimerProps {
  /** 'dark' for navy backgrounds, 'light' for cream/white backgrounds */
  variant?: 'dark' | 'light';
  label?: string;
}
export function CountdownTimer({
  variant = 'dark',
  label = '¡Tu oferta expira en!'
}: CountdownTimerProps) {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className={`flex items-center justify-center gap-2.5 sm:gap-3 rounded-xl px-3 py-2 sm:px-4 sm:py-2.5 ${variant === 'dark' ? 'bg-red/20 border border-red/40' : 'bg-red/10 border border-red/30'}`} data-id="element-61">
      <motion.div animate={{
      scale: [1, 1.15, 1]
    }} transition={{
      duration: 1,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="flex-shrink-0" data-id="element-62">
        <FlameIcon className="w-4 h-4 sm:w-5 sm:h-5 text-red" fill="#c0392b" strokeWidth={1.5} data-id="element-63" />
      </motion.div>

      <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-wide ${variant === 'dark' ? 'text-white/90' : 'text-red'}`} data-id="element-64">
        {label}
      </span>

      <div className="flex items-center gap-1" data-id="element-65">
        <TimeBox value={pad(mins)} data-id="element-66" />
        <span className={`font-display font-bold text-base sm:text-xl ${variant === 'dark' ? 'text-gold-light' : 'text-red'}`} data-id="element-67">
          :
        </span>
        <TimeBox value={pad(secs)} pulse data-id="element-68" />
      </div>
    </div>;
}
function TimeBox({
  value,
  pulse
}: {
  value: string;
  pulse?: boolean;
}) {
  return <motion.span key={value} initial={pulse ? {
    scale: 1.2,
    opacity: 0.6
  } : false} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    duration: 0.25
  }} className="bg-red text-white font-display font-bold text-base sm:text-xl px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md min-w-[28px] sm:min-w-[36px] text-center tabular-nums" data-id="element-69">
      {value}
    </motion.span>;
}